<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('little jars')"
      :columns="columns"
      :column_search="true"
      resource_url="/little_jar/datatables"
      mode="grid"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
      <template #item="item">
        <div class="card">
          <div class="card-image">
            <div
              class="is-pulled-right has-text-danger"
              :data-tooltip="$t('delete')"
              @click="remove(item)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </div>
            <div
              class="is-pulled-right has-text-warning"
              :data-tooltip="$t('edit')"
              @click="edit(item)"
            >
              <span class="icon"><i class="fa fa-edit"></i></span>
            </div>
            <figure class="image is-64x64 m-auto" v-if="!item.settings.images">
              <img
                src="https://cdn-icons-png.flaticon.com/512/2004/2004726.png"
              />
            </figure>
            <div v-else @click="edit(item)">
              <figure
                style="display: inline-flex; padding: 0 5px"
                class="image is-64x64 m-auto"
                v-for="(img, iidx) in item.settings.images"
                :key="iidx"
              >
                <v-lazy-image
                  :src="`${api_host}/drive/static/${img.final_name}`"
                />
              </figure>
            </div>
          </div>
          <div class="card-content px-0" @click="edit(item)">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ item.name }}
                </p>
                <!-- <pre>{{ item }}</pre> -->
              </div>
            </div>
          </div>
          <footer class="card-footer" v-show="false">
            <a
              class="card-footer-item button"
              :data-tooltip="$t('edit')"
              @click="edit(item)"
            >
              <span class="icon"><i class="fa fa-edit"></i></span>
            </a>
            <a
              class="card-footer-item has-text-danger button"
              :data-tooltip="$t('delete')"
              @click="remove(item)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </a>
            <a
              class="card-footer-item button"
              :data-tooltip="$t('file list')"
              @click="file_list(item)"
            >
              <span class="icon"><i class="fa fa-list"></i></span>
            </a>
          </footer>
        </div>
      </template>
    </generic-table>
  </div>

  <little-jar-modal ref="little_jar_modal" @success="refresh" />
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  api_host,
  del,
  error_message,
} from "@/utils";
import LittleJarModal from "./little_jar_modal/Index.vue";
import VLazyImage from "v-lazy-image";

export default {
  name: "LittleJarDatatable",
  components: { GenericTable, LittleJarModal, VLazyImage },
  data() {
    let v = this;
    return {
      api_host,
      columns: [
        {
          title: v.$t("data"),
          // name: "name",
          searchable: false,
          width: "50%",
          data: (row) => {
            return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.little_jar_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete little jar?"),
                    v,
                    () => {
                      del("/little_jar", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.little_jar_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    remove(item) {
      let v = this;
      let uuid = item.uuid;
      confirm_deletion_dialog(
        v.$t("are you sure to delete little jar?"),
        v,
        () => {
          del("/little_jar", { uuid: uuid })
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    edit(item) {
      let v = this;
      v.$refs.little_jar_modal.show_modal(item.uuid);
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
